import { z } from 'zod';
import { Mesh } from 'three';

export enum CadObjectShapeType {
  COMPOUND = 'compound',
  SOLID = 'solid',
  SHELL = 'shell',
  WIRE = 'wire',
}

export const CadObjectSummarySchema = z.object({
  id: z.number(),
  index: z.number(),
  type: z.enum(CadObjectShapeType),
  name: z.string(),
  step_ident: z.string(),
  parent_id: z.number().nullable(),
  get children() {
    return z.array(CadObjectSummarySchema);
  },
  cad_file_id: z.number(),
});

export type CadObjectSummary = z.infer<typeof CadObjectSummarySchema>;

export const CadObjectSchema = z.object({
  id: z.number(),
  index: z.number(),
  type: z.enum(CadObjectShapeType),
  name: z.string(),
  step_ident: z.string(),
  created_date: z.string(),
  ply_connected_url: z.string().nullable(),
  ply_disconnected_url: z.string().nullable(),
  solid_volume: z.number().nullable(),
  surface_area: z.number().nullable(),
  bounding_box_dimensions: z.array(z.number()).nullable(),
  center: z.array(z.number()).nullable(),
  center_of_mass: z.array(z.number()).nullable(),
  outer_edge_length: z.number().nullable(),
  cutout_edge_length: z.number().nullable(),
  holes_edge_length: z.number().nullable(),
  complexity: z.string().nullable(),
  new_topo_faces: z.array(z.number()).nullable().optional(),
  parent_id: z.number().nullable(),
  get children() {
    return z.array(CadObjectSchema);
  },
  cad_file_id: z.number(),
});

export type CadObject = z.infer<typeof CadObjectSchema> & {
  plyBlob?: Blob | null; // Fetched client-side from ply_connected_url or ply_disconnected_url
  mesh?: Mesh | null; // Built client-side for rendering in build-mesh.ts using the plyBlob; not part of the API response
};
